export default JSON.parse(process.env.public) as guesthouse.PublicConfig;
